import React, { Ref } from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';

interface IProps {
    cardColor?: string;
    dragged?: boolean;
    children?: React.ReactNode;
}

const AnimatedCard = React.forwardRef(
    (props: IProps, ref: Ref<HTMLInputElement>) => {
        const { cardColor, dragged, ...other } = props;

        return <animated.div ref={ref} {...other} />;
    }
);

export const BaseCard = styled(AnimatedCard)<IProps>`
    font-weight: 300;
    font-size: 28px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
`;
